import {
  AfterContentInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  QueryList,
  SimpleChanges,
  HostBinding,
  ContentChildren,
  ChangeDetectionStrategy
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { NgxExcelColumn, NgxExcelRow } from '../../models/models';
import { NgxExcelController } from '../../services/services';
import { NgxExcelComponent, NgxExcelComponentRef } from '../ngx-excel/ngx-excel.component';
import { NgxExcelCellComponent } from '../ngx-excel-cell/ngx-excel-cell.component';
import { NgxExcelHeadCellComponent } from '../ngx-excel-cell/ngx-excel-head-cell.component';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Component({
  selector: 'ngx-excel-context',
  template: '<ng-content></ng-content>',
  providers: [NgxExcelController],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxExcelContextComponent implements OnInit, OnChanges, AfterContentInit {

  protected selectedExcelCellComponent: any;
  private _initialed = false;
  private _readonly = false;
  private _compact = false;

  @Input() context: any;
  @Input() excel: NgxExcelComponent;
  @Input() attachSelectTo: NgxExcelContextComponent;
  @Input() attachTo: NgxExcelContextComponent;
  @Input() scene: 'list' | 'table';

  @Input()
  set readonly(value: boolean) { this._readonly = value === false ? false : true; }
  get readonly(): boolean { return this._readonly; }

  @Input()
  set compact(value: boolean) { this._compact = value === false ? false : true; }
  get compact(): boolean { return this._compact; }

  // @Output() changeContext = new EventEmitter<NgxExcelContextChanged[]>();
  @Output() contextChange = new EventEmitter<any>();

  @HostBinding('class.ngx-excel-context') excelContextClass = true;
  @HostBinding('class.normal') normalClass = true;

  @ContentChildren(NgxExcelCellComponent) protected excelCellComponents: QueryList<NgxExcelCellComponent>;
  @ContentChildren(NgxExcelHeadCellComponent) protected excelHeadCellComponents: QueryList<NgxExcelHeadCellComponent>;

  constructor(
    protected message: NzMessageService,
    protected controller: NgxExcelController,
    @Optional() @Inject(NgxExcelComponentRef) protected excelComponent: NgxExcelComponent
  ) { }

  ngOnInit() {
    this.normalClass = !this._readonly;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.context || changes.context.isFirstChange()) { return; }
    this.excelCellComponents.forEach((excelCellComponent) => {
      excelCellComponent.writeValue(this.context);
    });
  }

  ngAfterContentInit() {
    const excelComponent = this._getExcelComponent();
    const scene = this.scene || (excelComponent ? 'list' : (this.compact ? 'compact' : 'table'));
    const contextMenuComponent = excelComponent ? excelComponent.getContextMenuComponent() : null;
    this.excelHeadCellComponents.forEach((excelHeadCellComponent) => {
      // åºæ¯æ³¨å
      excelHeadCellComponent.registerScene(scene);
    });
    this.excelCellComponents.forEach((excelCellComponent) => {
      // ç»å®ååæ ¼åè°äºä»¶
      this._bindExcelCellCallbackFns(excelCellComponent);
      // å¦æ context æ¯åªè¯»åææååæ ¼é½ä¸å¯ç¼è¾
      if (this.readonly) { excelCellComponent.disabled = true; }
      // æ³¨åä¸ä¸æèå
      excelCellComponent.registerContextMenu(contextMenuComponent);
      // åºæ¯æ³¨å
      excelCellComponent.registerScene(scene);
      excelCellComponent.writeValue(this.context, true);
    });
    this._initialed = true;
  }

  /**
   * åå§åååæ ¼ç»ä»¶
   * @param cellComponent ååæ ¼ç»ä»¶
   */
  public initialCellComponent(cellComponent: NgxExcelHeadCellComponent | NgxExcelCellComponent) {
    if (!this._initialed) { return; }
    const excelComponent = this._getExcelComponent();
    const scene = this.scene || (excelComponent ? 'list' : (this.compact ? 'compact' : 'table'));
    const contextMenuComponent = excelComponent ? excelComponent.getContextMenuComponent() : null;
    if (cellComponent instanceof NgxExcelHeadCellComponent) {
      // åºæ¯æ³¨å
      cellComponent.registerScene(scene);
    } else {
      // ç»å®ååæ ¼åè°äºä»¶
      this._bindExcelCellCallbackFns(cellComponent);
      // å¦æ context æ¯åªè¯»åææååæ ¼é½ä¸å¯ç¼è¾
      if (this.readonly) { cellComponent.disabled = true; }
      // æ³¨åä¸ä¸æèå
      cellComponent.registerContextMenu(contextMenuComponent);
      // åºæ¯æ³¨å
      cellComponent.registerScene(scene);
      cellComponent.writeValue(this.context, true);
    }
  }

  /**
   * è·å¾æ§å¶å¨
   */
  public getController(): NgxExcelController {
    if (this.attachTo) {
      return this.attachTo.getController();
    }
    const excelComponent = this._getExcelComponent();
    return excelComponent ? excelComponent.controller : this.controller;
  }

  /**
   * å½ååæ ¼å¼ååæ¶åºåæ­¥ä¼ åº context
   * @param column å½åååçåç»ä»¶æä¸ä¸ææ¨¡åé®å
   * @param newValue åååçå¼
   * @param ignoreReload å¿½ç¥å·æ°
   */
  protected handleValueChanged(column: NgxExcelColumn, newValue: any): Observable<any> {
    const model = Object.assign({}, this.context);
    model[column.name] = newValue;
    return this.getController().handleModelChanged(this.context, model, column.name).pipe(
      map((result) => {
        const excelComponent = this._getExcelComponent();
        if (excelComponent) {
          excelComponent.handleChangedContexts(result);
        } else {
          const filteredResult = result.find((resultRow) => resultRow.action === 'updated');
          this.contextChange.emit(filteredResult && filteredResult.context ? filteredResult.context : model);
        }
        return true;
      }),
      catchError((e) => {
        this._getErrorHandles()(e);
        return throwError(e);
      })
    );
  }

  /**
   * ç»å®ååæ ¼çåè°å½æ°
   * @param cellComponent ååæ ¼ç»ä»¶
   */
  private _bindExcelCellCallbackFns(cellComponent: NgxExcelCellComponent) {
    // æ³¨åå¤é® / å¤é®åè¡¨ååæ ¼æåå¯éé¡¹çåè°
    cellComponent.registerPullForeignModelsFn(
      (column, keyword) => this.getController().getForeignModels({ context: this.context } as NgxExcelRow, column, keyword)
    );
    // æ³¨åæåä¸æå¯éé¡¹çåè°
    cellComponent.registerPullSelectOptionsFn(
      (column) => this.getController().getSelectOptions({ context: this.context } as NgxExcelRow, column)
    );
    // æ³¨åååæ ¼æä»¶ä¸ä¼ æå¡å·¥å
    cellComponent.registerUploadServiceFactory(
      (payload: { [name: string]: string | Blob }) => this.getController().getUploadService(payload)
    );
    // åè°åççé¡ºåºï¼è·å¾ç¦ç¹ -> å¤æ­å¯å¦è¢«ç¼è¾ -> ç¼è¾åå®¹æ¯å¦ææ -> å¼åååè° -> å¤±å»ç¦ç¹
    // æ³¨åååæ ¼å¯å¦è¢«ç¼è¾çå¤æ­åè°
    cellComponent.registerCanEditFn(
      (column) => this.getController().canEdit({ context: this.context } as NgxExcelRow, column)
    );
    // æ³¨åååæ ¼å¼ååæ¯å¦ææçå¤æ­åè°
    cellComponent.registerValidateFn(
      (column, value) => this.getController().validate({ context: this.context } as NgxExcelRow, column, value)
    );
    // æ³¨åååæ ¼è·å¾ç¦ç¹æ¶çåè°
    cellComponent.registerOnTouch(
      (component, column) => {
        const controller = this.attachSelectTo ? this.attachSelectTo.getController() : this.getController();
        return controller.selectCell(component, { context: this.context } as NgxExcelRow, column);
      }
    );
    // æ³¨åååæ ¼å¤±å»ç¦ç¹æ¶çåè°
    cellComponent.registerOnTouched(null);
    // æ³¨åååæ ¼å¼åçååæ¶çåè°ï¼åçå¨æææ§å¤æ­ä¹åï¼
    cellComponent.registerOnChange(
      (column, value) => this.handleValueChanged(column, value)
    );
  }

  /**
   * è·å¾éè¯¯å¤çå½æ°
   */
  private _getErrorHandles() {
    return (e: any) => e && this.message.create('error', e.message || e);
  }

  /**
   * è·å¾ Excel ç»ä»¶
   */
  private _getExcelComponent(): NgxExcelComponent {
    return this.excel || this.excelComponent;
  }

}
